import { NumberInput, NumberInputProps } from '@mantine/core'

export default function BlackNumberInput({ classNames, ...props }: NumberInputProps) {
    return (
        <NumberInput
            classNames={{
                label: "black-input-label",
                input: "black-text-input-input",
                root: "black-text-input-root",
                ...classNames
            }}
            hideControls={true}
            {...props}
        />
    )
}
